import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';

import { Comment } from 'ThreeTerminal_pc/comment';
/**
 * for this page
 */
class CommentBox extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    state = {};

    render() {
        const { content } = this.props;
        const props = {
            docUrl: `sv_${content.id}`, // 文章单页的页面地址
            docTitle: content.title, // 文章的标题
            skey: content.skey, // 文章评论的skey，这个是在后端生成好后给到前端的
            pcUrl: location.href, // 文章pc的页面地址
            cmtNumUrl: 'http://comment.ifeng.com/get.php', // 获取评论内容接口
            cmtLength: 1000, // 评论内容字数长度
            cmtPostUrl: 'http://comment.ifeng.com/post.php', // 提交评论内容接口
            hotLimit: 3, // 最热评论数量
            limitHeight: '', // 评论区域的高度限制
            cmtVoteUrl: 'http://comment.ifeng.com/vote.php', // 推荐评论接口
            replyLimit: 5, // 显示回复的楼层
            jubUrl: 'http://comment.ifeng.com/report', // 举报提交接口
            jubNum: 0, // 举报次数，便于每次回调函数名不同
            isComment: false, // 是否是评论详情页面
            allowComment: true, // 是否允许评论
        };

        return (
            <div className={styles.commentBox}>
                <div className={styles.cmt_line} />
                <Comment articleInfo={props} />
            </div>
        );
    }
}

export default CommentBox;
